import { Building2, Users, Briefcase, FolderKanban } from 'lucide-react'

import type { OrganizationStatistics } from '@/hooks'

interface StatisticsCardsProps {
  statistics: OrganizationStatistics
}

export function StatisticsCards({ statistics }: StatisticsCardsProps) {
  const cards = [
    {
      title: '总人数',
      value: statistics.activeEmployees,
      subValue: `共 ${statistics.totalEmployees} 人`,
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: '部门数',
      value: statistics.departmentCount,
      icon: Building2,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: '团队数',
      value: statistics.teamCount,
      icon: Briefcase,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      title: '项目数',
      value: statistics.projectCount,
      icon: FolderKanban,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {cards.map((card) => (
        <div key={card.title} className="rounded-lg border bg-card p-4">
          <div className="flex items-center gap-3">
            <div className={`rounded-lg p-2 ${card.bgColor}`}>
              <card.icon className={`h-5 w-5 ${card.color}`} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{card.title}</p>
              <p className="text-2xl font-semibold">{card.value}</p>
              {card.subValue && (
                <p className="text-xs text-muted-foreground">{card.subValue}</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
